import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ValueType} from './directives/value-type.directive';
import { ToolbarComponent } from './toolbar/index';
import { FooterComponent } from './footer/index';
import { TooltipComponent } from './tooltip/index';
import { InfoModalComponent } from './modals/info-modal/index';
import { NotifyModalComponent } from './modals/notify-modal/notify-modal.component';
import { SecurityModalComponent } from './modals/security-modal/index';
import { NeedHelpComponent } from './modals/need-help-modal/index';
import { AlertModalComponent } from './modals/alert-modal/alert-modal.component';
import { ConfirmModalComponent } from './modals/confirm-modal/confirm-modal.component';
import { ModalService } from './modals/modal.service';
import { ProgressTrackerComponent } from './progress-tracker/progress-tracker.component';
import { LocationListComponent } from './location-list/location-list.component';
import { LocationFilterComponent } from './location-filter/location-filter.component';
import { CalendarComponent } from './calendar/calendar.component';
import { DayComponent } from './calendar/day.component';
import { CalendarFilterComponent } from './calendar-filter/calendar-filter.component';
import { LocationService } from './services/location.service';
import { ScheduleService } from './services/schedule.service';
import { SessionService } from './services/session.service';
import { RedirectService } from './services/redirect.service';
import { CalendarService } from './services/calendar.service';
import { WarnModalComponent } from './modals/warn-modal/warn-modal.component';
import { RegionListComponent } from './region-list/region-list.component';
import { PopoverComponent } from './popover/popover.component';
import { PopoverService } from './popover/popover.service';
import { TokenService } from './services/token.service';
import { TranslateModule } from '@ngx-translate/core';
import { CBSAService } from './services/cbsa.service';

/**
 * Do not specify providers for modules that might be imported by a lazy loaded module.
 */

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    FormsModule
  ],
  declarations: [
    ToolbarComponent,
    FooterComponent,
    TooltipComponent,
    InfoModalComponent,
    NotifyModalComponent,
    SecurityModalComponent,
    NeedHelpComponent,
    AlertModalComponent,
    ConfirmModalComponent,
    ProgressTrackerComponent,
    LocationListComponent,
    LocationFilterComponent,
    CalendarComponent,
    DayComponent,
    CalendarFilterComponent,
    WarnModalComponent,
    RegionListComponent,
    PopoverComponent,
    ValueType
  ],
  exports: [
    ToolbarComponent,
    CommonModule,
    FormsModule,
    RouterModule,
    FooterComponent,
    TooltipComponent,
    InfoModalComponent,
    NotifyModalComponent,
    SecurityModalComponent,
    NeedHelpComponent,
    AlertModalComponent,
    ConfirmModalComponent,
    ProgressTrackerComponent,
    LocationListComponent,
    LocationFilterComponent,
    CalendarComponent,
    DayComponent,
    CalendarFilterComponent,
    WarnModalComponent,
    RegionListComponent,
    PopoverComponent,
    ValueType
  ]
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [
        ModalService,
        LocationService,
        ScheduleService,
        SessionService,
        RedirectService,
        DatePipe,
        CalendarService,
        PopoverService,
        TokenService,
        CBSAService
      ]
    };
  }
}
